var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4C1.6 4 0 5.6 0 7.5S1.6 11 3.5 11h.1l2.6 4.3c.4.7 1.3.9 2.1.5.7-.4.9-1.3.5-2.1L7.1 11H9l7 4V0L9 4H3.5z",
    fill: "#212121"
  })));
}
export default SvgHorn;